export default "__VITE_ASSET___fBoA2DF__"